import React from "react";
import { Link } from "react-router-dom";
import { GrView } from "react-icons/gr";
import Slider from '../slider/swiperProduct';
import ShowimagesLoading from "./showImagesLoading";
import { resolveCategoryImageUrl } from "../../config";
import CategoryMatrixPreview, { getMatrixChildren } from "./CategoryMatrixPreview";

const CardAllcategories0 = (props) => {
    const {
        infoSource,
        setLevel,
        level,
        matrixParents
    } = props;

    // Matrix Mode -- each display reads its DIRECT parent's own flag only:
    //   level_2 (the selected sub-category) is a child of level.id (the
    //   opened category card), level_2.items are children of level_2.
    const selectedMatrixChildren = getMatrixChildren(matrixParents, level?.id);
    const subCategoriesMatrix = getMatrixChildren(matrixParents, level?.level_2?._id);

    const ButtonViewCategories = (ar) => {
        setLevel({
            ...level,
            level_2: ar
        });
    };

    const isMobileDevice = (device) => {
        return device === "iPhone" || device === "Android Phone";
    };

    const level0 = () => (
        <ul className="ec-detail-list">
            {level?.level_1 && level?.level_1?.map((m, i) => (
                <li
                    key={i}
                    className={`ec-detail-item${level?.level_2?._id === m?.supCategoryID?._id ? " ec-detail-item--active" : ""}`}
                    onClick={() => ButtonViewCategories(m?.supCategoryID)}
                >
                    {infoSource?.getCategoryNames(m)?.name[0]}
                </li>
            ))}
        </ul>
    );

    // DB URL first (image_r.photoUrl / urlImg) -- resolveCategoryImageUrl()
    // already falls back to urlImg internally, so this only differs from the
    // old `image_r.urlImg`-only read when a newer photoUrl asset exists.
    const rectangleImageUrl = resolveCategoryImageUrl(level?.level_2, { variant: "rectangle" });

    const level0MatrixView = () => (
        level?.level_2?._id && (
            <div className="ec-detail-media">
                <Link to={`/product/${level?.level_2?.publicId || level?.level_2?._id}`} className="ec-detail-media-link">
                    <CategoryMatrixPreview
                        products={selectedMatrixChildren[String(level.level_2._id)] || []}
                        label={infoSource?.getCategoryNames?.(level.level_2, true)?.name?.[0] || level?.level_2?.name?.[0]}
                        fallbackSrc={rectangleImageUrl}
                    />
                    <span className="ec-detail-media-badge">
                        <GrView />
                        {infoSource?.laguangeElakay('title', infoSource?.languageAPI)?.viewPage}
                    </span>
                </Link>
            </div>
        )
    );

    const level0View = () => selectedMatrixChildren ? level0MatrixView() : (
        level?.level_2?.image_r &&
        rectangleImageUrl && (
            <div className="ec-detail-media">
                <Link to={`/product/${level?.level_2?.publicId || level?.level_2?._id}`} className="ec-detail-media-link">
                    <ShowimagesLoading
                        className="rounded"
                        src={rectangleImageUrl}
                        width={300}
                        alt={level?.level_2?.name}
                        style={{ width: "100%", height: "100%", objectFit: "cover" }}
                    />
                    <span className="ec-detail-media-badge">
                        <GrView />
                        {infoSource?.laguangeElakay('title', infoSource?.languageAPI)?.viewPage}
                    </span>
                </Link>
            </div>
        )
    );

    const level1 = () =>
        level?.level_2?.items?.length > 0 && (
            <div className="ec-detail-products">
                <Slider
                    infoSource={infoSource}
                    circle={true}
                    wm0={3}
                    ProductSwiper={level?.level_2?.items}
                    classSlider={"container"}
                    sliderShow={true}
                    categoryMatrix={subCategoriesMatrix}
                />
            </div>
        );

    return (
        <div className="ec-detail">
            <div className="ec-detail-row">
                <div className="ec-detail-sidebar">
                    {level0()}
                </div>
                {level0View()}
            </div>
            {level1()}
        </div>
    );
};

export default CardAllcategories0;
